// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__PquE4","link":"styles_link__209Bg"};